import React, { useState } from "react";
import { clsx } from "clsx";

import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "@src/../entrypoints/theme";
import { ProductTileQuickAddModal } from "../ProductTileQuickAddModal/ProductTileQuickAddModal";

export const ProductTileQuickAction = ({ product, type = 'add' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  const firstVariant = product?.variants?.[0];

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (type === 'view') {
      window.dispatchEvent(
        new CustomEvent("quickview:open", {
          detail: { handle: product.handle, title: product.title },
        })
      );
    } else {
      setIsOpen(true);
    }
  };

  return (
    <>
      {!isOpen && (
        <>
          {isMobile ? (
            <>
              {product?.variants?.length === 1 && type === 'add' ? (
                <ajax-cart-product-form>
                  <form
                    action="/cart/add"
                    id="product_form_id"
                    className="w-full"
                    noValidate
                    data-prodify-product-form
                    onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
                  >
                    <input type="hidden" name="id" value={`${firstVariant?.id}`} />

                    <button
                      type="submit"
                      className="w-fit"
                      disabled={!firstVariant}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                        <path d="M9.16667 6.66667C9.625 6.66667 10 6.29167 10 5.83333V4.16667H11.6667C12.125 4.16667 12.5 3.79167 12.5 3.33333C12.5 2.875 12.125 2.5 11.6667 2.5H10V0.833333C10 0.375 9.625 0 9.16667 0C8.70833 0 8.33333 0.375 8.33333 0.833333V2.5H6.66667C6.20833 2.5 5.83333 2.875 5.83333 3.33333C5.83333 3.79167 6.20833 4.16667 6.66667 4.16667H8.33333V5.83333C8.33333 6.29167 8.70833 6.66667 9.16667 6.66667ZM5 14.1667C4.08333 14.1667 3.34167 14.9167 3.34167 15.8333C3.34167 16.75 4.08333 17.5 5 17.5C5.91667 17.5 6.66667 16.75 6.66667 15.8333C6.66667 14.9167 5.91667 14.1667 5 14.1667ZM13.3333 14.1667C12.4167 14.1667 11.675 14.9167 11.675 15.8333C11.675 16.75 12.4167 17.5 13.3333 17.5C14.25 17.5 15 16.75 15 15.8333C15 14.9167 14.25 14.1667 13.3333 14.1667ZM5.91667 10H12.125C12.75 10 13.3 9.65833 13.5833 9.14167L16.2833 4.025C16.4917 3.625 16.35 3.125 15.95 2.90833C15.5417 2.68333 15.0333 2.84167 14.8167 3.25L12.125 8.33333H6.275L2.725 0.833333H0.833333C0.375 0.833333 0 1.20833 0 1.66667C0 2.125 0.375 2.5 0.833333 2.5H1.66667L4.66667 8.825L3.54167 10.8583C2.93333 11.975 3.73333 13.3333 5 13.3333H14.1667C14.625 13.3333 15 12.9583 15 12.5C15 12.0417 14.625 11.6667 14.1667 11.6667H5L5.91667 10Z" fill="#00263E"/>
                      </svg>
                    </button>

                    <div data-ajax-cart-errors="form" className="text-xs text-error-1"></div>
                  </form>
                </ajax-cart-product-form>
              ) : (
                <button
                  className="w-fit "
                  onClick={handleClick}
                >
                  {type === 'view' ? (
                    <span class="icon-plus"></span>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                      <path d="M9.16667 6.66667C9.625 6.66667 10 6.29167 10 5.83333V4.16667H11.6667C12.125 4.16667 12.5 3.79167 12.5 3.33333C12.5 2.875 12.125 2.5 11.6667 2.5H10V0.833333C10 0.375 9.625 0 9.16667 0C8.70833 0 8.33333 0.375 8.33333 0.833333V2.5H6.66667C6.20833 2.5 5.83333 2.875 5.83333 3.33333C5.83333 3.79167 6.20833 4.16667 6.66667 4.16667H8.33333V5.83333C8.33333 6.29167 8.70833 6.66667 9.16667 6.66667ZM5 14.1667C4.08333 14.1667 3.34167 14.9167 3.34167 15.8333C3.34167 16.75 4.08333 17.5 5 17.5C5.91667 17.5 6.66667 16.75 6.66667 15.8333C6.66667 14.9167 5.91667 14.1667 5 14.1667ZM13.3333 14.1667C12.4167 14.1667 11.675 14.9167 11.675 15.8333C11.675 16.75 12.4167 17.5 13.3333 17.5C14.25 17.5 15 16.75 15 15.8333C15 14.9167 14.25 14.1667 13.3333 14.1667ZM5.91667 10H12.125C12.75 10 13.3 9.65833 13.5833 9.14167L16.2833 4.025C16.4917 3.625 16.35 3.125 15.95 2.90833C15.5417 2.68333 15.0333 2.84167 14.8167 3.25L12.125 8.33333H6.275L2.725 0.833333H0.833333C0.375 0.833333 0 1.20833 0 1.66667C0 2.125 0.375 2.5 0.833333 2.5H1.66667L4.66667 8.825L3.54167 10.8583C2.93333 11.975 3.73333 13.3333 5 13.3333H14.1667C14.625 13.3333 15 12.9583 15 12.5C15 12.0417 14.625 11.6667 14.1667 11.6667H5L5.91667 10Z" fill="#00263E"/>
                    </svg>
                  )}
                </button>
              )}
            </>
          ) : (
            <>
              {product?.variants?.length === 1 && type === 'add' ? (
                <ajax-cart-product-form>
                  <form
                    action="/cart/add"
                    id="product_form_id"
                    className="w-full"
                    noValidate
                    data-prodify-product-form
                    onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
                  >
                    <input type="hidden" name="id" value={`${firstVariant?.id}`} />

                    <button
                      type="submit"
                      className="quick-action quick-action--desktop btn btn-primary w-full absolute bottom-0 left-0 z-20 !rounded-none flex items-center justify-center gap-2"
                      disabled={!firstVariant}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <span>Quick Add</span>
                      <span className="icon-chevron-right text-white text-[20px]"></span>
                    </button>

                    <div data-ajax-cart-errors="form" className="text-xs text-error-1"></div>
                  </form>
                </ajax-cart-product-form>
              ) : (
                <button
                  type="button"
                  className="quick-action quick-action--desktop btn btn-primary w-full absolute bottom-0 left-0 z-20 !rounded-none flex items-center justify-center gap-2"
                  onClick={handleClick}
                >
                  <span className="uppercase">
                    Quick {type === 'view' ? 'View' : 'Add'}
                  </span>
                  <span className="icon-chevron-right text-white text-[20px]"></span>
                </button>
              )}
            </>
          )}
        </>
      )}

      {isOpen && type === 'add' && (
        <ProductTileQuickAddModal
          product={product}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default ProductTileQuickAction;